const SplineAnimation = () => {
  return (
    <iframe
      className="splineAnimation onlyDesktop"
      src="https://my.spline.design/lightingbunnycopy-116e10576aac2deed8579d4297d0b99e/"
      frameBorder="0"
      width="100%"
      height="100%"
    ></iframe>
  );
};
export default SplineAnimation;
